// src/components/MobileLogin.js
import React, { useState } from "react";
import "./Login.css";

// Reuse the same subcomponents for the mobile flow
import LoginForm from "./LoginForm";
import ResetPassword from "./ResetPassword";
import VerifyCode from "./VerifyCode";
import Register from "../Register/Register";
import { usePasswordResetDeepLink } from "./usePasswordResetDeepLink";

function MobileLogin() {
  const [isResetPass, setIsResetPass] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const { showResetVerify, resetVerifyEmail, verificationCodeFromUrl } =
    usePasswordResetDeepLink();

  // If user chooses to register
  if (isRegister) {
    return (
      <div>
        <div className="mobile-login-header">
          <img src="/moblogo.svg" alt="mobile logo" />
        </div>
        <div className="mobile-login-form-banner">
          <img className="mobbanner" src="/mobwelcome.svg" alt="mobile banner" />
        </div>
        <div className="mobile-login-form">
          <Register />
        </div>
      </div>
    );
  }

  if (showResetVerify) {
    return (
      <div>
        <div className="mobile-login-header">
          <img src="/moblogo.svg" alt="mobile logo" />
        </div>
        <div className="mobile-login-form-banner">
          <img className="mobbanner" src="/mobwelcome.svg" alt="mobile banner" />
        </div>
        <div className="mobile-login-form">
          <VerifyCode
            key={`${resetVerifyEmail}-${verificationCodeFromUrl}`}
            email={resetVerifyEmail}
            initialCode={verificationCodeFromUrl}
            setIsResetPass={setIsResetPass}
          />
        </div>
      </div>
    );
  }

  if (isResetPass) {
    return (
      <div>
        <div className="mobile-login-header">
          <img src="/moblogo.svg" alt="mobile logo" />
        </div>
        <div className="mobile-login-form-banner">
          <img className="mobbanner" src="/mobwelcome.svg" alt="mobile banner" />
        </div>
        <div className="mobile-login-form">
          <ResetPassword setIsResetPass={setIsResetPass} />
        </div>
      </div>
    );
  }

  // Otherwise, show the Login form by default
  return (
    <div>
      <div className="mobile-login-header">
        <img src="/moblogo.svg" alt="mobile logo" />
      </div>
      <div className="mobile-login-form-banner">
        <img className="mobbanner" src="/mobwelcome.svg" alt="mobile banner" />
      </div>
      <div className="mobile-login-form">
        {/* We pass down setIsRegister so the login form can redirect to register */}
        <LoginForm setIsResetPass={setIsResetPass} setIsRegister={setIsRegister} />
      </div>
    </div>
  );
}

export default MobileLogin;
